import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAppStore } from '../store/appStore';
import { adminLogin, fetchAuthMe } from '../services/api';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const form = e.target as HTMLFormElement;
    const username = (form.elements.namedItem('username') as HTMLInputElement).value.trim();
    const password = (form.elements.namedItem('password') as HTMLInputElement).value;

    try {
      const data = await adminLogin({ username, password });
      if (data.success) {
        const user = await fetchAuthMe();
        navigate('/', { replace: true });
      } else {
        setError(data.error || 'Login failed');
      }
    } catch (err: any) {
      const serverMessage = err?.response?.data?.error;
      setError(serverMessage || 'Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle: React.CSSProperties = {
    width: '100%', padding: '10px 14px', border: '1px solid #e2e8f0',
    borderRadius: 6, fontSize: 14, fontFamily: 'inherit', color: '#1a202c',
    background: '#f8fafc', outline: 'none',
  };

  return (
    <div style={{
      fontFamily: "'JohnsonText', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 50%, #fef2f2 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        width: 420, background: 'white', borderRadius: 12,
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)', overflow: 'hidden',
      }}>
        <div style={{ padding: '32px 36px 20px', borderBottom: '1px solid #f1f5f9' }}>
          <div style={{ display: 'flex', flexDirection: 'column', color: '#eb1923', lineHeight: 1, marginBottom: 6 }}>
            <span style={{ fontSize: 16, fontWeight: 700, letterSpacing: -0.3, marginBottom: 2 }}>Johnson&Johnson</span>
            <span style={{ fontSize: 22, fontWeight: 500, letterSpacing: -0.6 }}>MedTech</span>
          </div>
          <div style={{ color: '#64748b', fontSize: 13, marginTop: 8 }}>AI Highlight - Admin</div>
        </div>

        <div style={{ padding: '28px 36px 36px' }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#1a202c', marginBottom: 16 }}>Admin Login</div>

          {error && (
            <div style={{
              background: '#fef2f2', color: '#dc2626', padding: '10px 14px',
              borderRadius: 6, fontSize: 13, marginBottom: 14,
            }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#4a5568', marginBottom: 6 }}>
                Username
              </label>
              <input
                type="text"
                name="username"
                autoComplete="username"
                required
                autoFocus
                style={inputStyle}
                onFocus={(e) => { e.target.style.borderColor = '#eb1923'; e.target.style.boxShadow = '0 0 0 3px rgba(235,25,35,0.1)'; e.target.style.background = 'white'; }}
                onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none'; e.target.style.background = '#f8fafc'; }}
              />
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#4a5568', marginBottom: 6 }}>
                Password
              </label>
              <input
                type="password"
                name="password"
                autoComplete="current-password"
                required
                style={inputStyle}
                onFocus={(e) => { e.target.style.borderColor = '#eb1923'; e.target.style.boxShadow = '0 0 0 3px rgba(235,25,35,0.1)'; e.target.style.background = 'white'; }}
                onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none'; e.target.style.background = '#f8fafc'; }}
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%', padding: '11px 16px', borderRadius: 6, fontSize: 14,
                fontWeight: 600, fontFamily: 'inherit', cursor: loading ? 'not-allowed' : 'pointer',
                background: loading ? '#fca5a5' : '#eb1923', color: 'white', border: 'none',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              }}
            >
              {loading ? (
                <>
                  Logging in...
                  <div style={{
                    width: 16, height: 16, border: '2px solid rgba(255,255,255,0.3)',
                    borderTopColor: 'white', borderRadius: '50%',
                    animation: 'spin 0.6s linear infinite',
                  }} />
                </>
              ) : 'Login'}
            </button>
          </form>

          <div style={{ marginTop: 14, textAlign: 'right', fontSize: 12 }}>
            <Link to="/login-manual" style={{ color: '#94a3b8', textDecoration: 'none' }}>
              Back to D365 Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
